import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SupportButton } from '../../../../../containers/SupportButton/component';
import { ErrorState } from '../../../../error-boundary-context/types';
import { useCurrentError } from '../../../../error-boundary-context/context';
import { ErrorOverlayBody } from '../../error/error-overlay-body/component';
import { ErrorOverlay } from '../../error/error-overlay/component';
import styles from '../styles.module.css';
import { getOverlayBottom } from '../default-error/utils';

interface DrmErrorProps {
    isErrorUnknown?: boolean;
}

export const DrmErrorUnknown: React.FC<DrmErrorProps> = ({ isErrorUnknown = true }) => {
    const intl = useIntl();

    const { vsid, sessionId, name } = useCurrentError() as {
        vsid?: string;
        sessionId?: string;
        name: ErrorState['name'];
    };

    return (
        <ErrorOverlay>
            <ErrorOverlayBody>
                <div className={styles.mainText}>
                    {isErrorUnknown ? (
                        <>
                            <div>
                                <FormattedMessage
                                    id="features.player.6c97a6bcd145ba16eaa2cc54f6b0dad8"
                                    defaultMessage="Couldn't play the video"
                                    description="Текст ошибки, если не удалось воспроизвести видео в плеере"
                                />
                            </div>
                            <div>
                                <FormattedMessage
                                    id="features.player.38a7f40bd8feda6539419958b6ecc4ad"
                                    defaultMessage="Contact support —"
                                    description="Текст ошибки, если не удалось воспроизвести видео в плеере"
                                />
                            </div>
                            <div>
                                <FormattedMessage
                                    id="features.player.07078ab564277fa3cbbaa40b2afa2723"
                                    defaultMessage="we'll sort everything out"
                                    description="Текст ошибки, если не удалось воспроизвести видео в плеере"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                <FormattedMessage
                                    id="features.player.46c27713f7874250400156b005aff5d9"
                                    defaultMessage="Video playback"
                                    description="Текст ошибки, если воспроизведение видео не поддерживается на устройстве в плеере"
                                />
                            </div>
                            <div>
                                <FormattedMessage
                                    id="features.player.2563205bdb16041307be9ff7df88620b"
                                    defaultMessage="is unavailable. The device"
                                    description="Текст ошибки, если воспроизведение видео не поддерживается на устройстве в плеере"
                                />
                            </div>
                            <div>
                                <FormattedMessage
                                    id="features.player.5d81b1c6d43802b078d938a9fdeb0614"
                                    defaultMessage="is not supported"
                                    description="Текст ошибки, если воспроизведение видео не поддерживается на устройстве в плеере"
                                />
                            </div>
                        </>
                    )}
                </div>
                <SupportButton />
            </ErrorOverlayBody>
            {getOverlayBottom(intl, vsid, sessionId, name ?? undefined)}
        </ErrorOverlay>
    );
};
